import { Icon, StampType } from '@pelando/components';
import { useRouter } from 'next/router';
import React from 'react';
import { Ghost } from '@pelando/fontawesome/icons';
import useHashCouponModal from '../../../hooks/useHashCouponModal';
import { getStampByType } from '../../../services/stamp';
import { getAddOfferUrl } from '../../../services/urls';
import StoreCouponCard from '../StoreCouponCard';
import { CouponsEmptyState, StoreCouponsTabContainer } from './style';
import { StoreDeal } from '../../../../domain/entities/Store';
import { useTranslation } from '../../../hooks/useTranslation';

export type StoreTabCouponContentProps = {
  revealCoupons: boolean;
  storeCoupons?: StoreDeal[];
  currentUserId?: string;
};

const StoreTabCouponContent = ({
  revealCoupons,
  storeCoupons,
  currentUserId,
}: StoreTabCouponContentProps) => {
  const { t } = useTranslation('coupons');
  const router = useRouter();

  const coupons = storeCoupons || [];

  useHashCouponModal({
    enabled: revealCoupons,
    coupons,
    isExpiredCoupon: false,
  });

  if (!coupons?.length) {
    const emptyStateProps = {
      icon: <Icon icon={Ghost} />,
      title: t('empty-state-coupon-title'),
      buttonTitle: t('empty-state-coupon-button'),
      content: t('empty-state-coupon-content'),
      onClick: () => router.push(getAddOfferUrl()),
    };

    return <CouponsEmptyState {...emptyStateProps} />;
  }

  return (
    <StoreCouponsTabContainer>
      {coupons?.map((deal) => {
        const stamps = {
          discountPercentage: !!deal.discountPercentage,
          discountFixed: !!deal.discountFixed,
          freeShipping: deal.freeShipping,
          price: !!deal.price,
        };
        const stamp = getStampByType(stamps) as StampType;
        return (
          <StoreCouponCard
            key={deal.id}
            deal={deal}
            stamp={stamp}
            revealCoupons={revealCoupons}
            currentUserId={currentUserId}
          />
        );
      })}
    </StoreCouponsTabContainer>
  );
};

export default StoreTabCouponContent;
